import { render } from "./InfoMsg.vue?vue&type=template&id=52ccd3c8&lang=pug"
import script from "./InfoMsg.vue?vue&type=script&lang=js"
export * from "./InfoMsg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/inputs/InfoMsg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52ccd3c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52ccd3c8', __exports__)) {
    api.reload('52ccd3c8', __exports__)
  }
  
  module.hot.accept("./InfoMsg.vue?vue&type=template&id=52ccd3c8&lang=pug", () => {
    api.rerender('52ccd3c8', render)
  })

}


export default __exports__